import AirtableValidator from './AirtableValidator'
import CanvaValidator from './CanvaValidator'
import FigmaValidator from './FigmaValidator'
import GoogleValidator from './GoogleValidator'
import DropboxValidator from './DropboxValidator'
import PDFValidator from './PDFValidator'
import { FileType, ValidationResult } from '../urlValidationUtils'

export const VALIDATE_URL_FOR: Record<FileType | string, (url: string) => ValidationResult> = {
  [FileType.AIRTABLE]: AirtableValidator,
  [FileType.CANVA]: CanvaValidator,
  [FileType.FIGMA]: FigmaValidator,
  [FileType.DROPBOX]: DropboxValidator,
  [FileType.GOOGLE]: GoogleValidator,
  [FileType.PDF]: PDFValidator,
} as const
